<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref, watch} from "vue";
import {useContratTemplateStore} from "@/stores/ContratTemplate";
import axios from "axios";

export default {
    props: {
        value: Number,
        data: Array,
        rules: Array,
        readonly: Boolean,
        label: String,
    },
    emits: ["change"],
    setup(props, { emit }) {
        const {loading, inputColor, backgroundColor} = useSharedData();

        const contratTemplateStore = useContratTemplateStore();

        const contratTemplate = ref(null);


        function findAll() {
            loading.value = true;
            axios.get('/contratTemplates/selections').then(response => {
                contratTemplateStore.setContratTemplates(response.data);
            }).finally(() => {
                loading.value = false;
            });

        }

        function change() {
            emit('change');
        }

        watch(() => props.value, () => {
            contratTemplate.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            loading,
            inputColor,
            backgroundColor,
            contratTemplate,
            contratTemplateStore,
            change,
        }
    },
};
</script>

<template>
    <div>
        <v-autocomplete
            v-model="contratTemplate"
            :label="label"
            :items="contratTemplateStore.contratTemplates"
            item-value="id"
            item-text="name"
            outlined
            dense
            :clearable="!readonly"
            :readonly="readonly"
            :loading="loading"
            :color="inputColor"
            :background-color="backgroundColor"
            hide-details="auto"
            @input="$emit('input', contratTemplate)"
            @change="change"
            :rules="rules"
        />

        <input type="hidden"/>
    </div>
</template>